interface ChevronProps {
  type: 'up' | 'down'
  size: number
}

export const Chevron = ({ type, size }: ChevronProps): JSX.Element => {
  const baseViewBoxSize = 16
  const scaleFactor = size / baseViewBoxSize

  // Function to scale a single coordinate
  const scaleCoordinate = (coord: number): number => coord * scaleFactor

  // Generate scaled path data
  const upPath = `M${scaleCoordinate(4.5)} ${scaleCoordinate(10)}L${scaleCoordinate(8)} ${scaleCoordinate(6.5)}L${scaleCoordinate(11.5)} ${scaleCoordinate(10)}`
  const downPath = `M${scaleCoordinate(4.5)} ${scaleCoordinate(6)}L${scaleCoordinate(8)} ${scaleCoordinate(9.5)}L${scaleCoordinate(11.5)} ${scaleCoordinate(6)}`

  return (
    <svg
      width={size}
      height={size}
      // The viewBox should match the target size to ensure proper scaling
      viewBox={`0 0 ${size} ${size}`}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d={type === 'up' ? upPath : downPath}
        stroke="#909090"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}
